import { createSelector } from '@reduxjs/toolkit';
import { defaultZoneNameSelector, locationSelector } from '..';

/**
 * Fetches the default zone name for the current user
 */
export const getDefaultZoneName = createSelector(
  defaultZoneNameSelector,
  (zoneName) => zoneName,
);

/**
 * Returns the current path
 * @param  {any} state
 * @return {string}
 */
export const getCurrentLocationPath = createSelector(locationSelector, (pathname) => pathname);
